import { PageHeader } from "@/components/common/PageHeader";
import { RelativesBoard } from "@/components/pots/RelativesBoard";
import { Birthdays } from "@/pages/Pots";

export default function Friends() {
  return (
    <div className="space-y-6" data-testid="friends-page">
      <PageHeader eyebrow="Contacts & invitations" title="Proches & amis" text="Gérez vos contacts, invitez vos amis sur CASHMY et gardez les anniversaires et idées cadeaux de chacun." />
      <Birthdays />
      <RelativesBoard />
    </div>
  );
}
